// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitsDueView-module__root___CS23J {
  display: block;
}

.VisitsDueView-module__toolbar___UkACy {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  margin-bottom: 8px;
}

.VisitsDueView-module__readout___sXbXA {
  margin-left: auto;
  font-size: 13px;
  color: #71717a;
}

.VisitsDueView-module__statsRow___G2L_N {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.VisitsDueView-module__statCard___GcBeg {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 12px 14px;
}

.VisitsDueView-module__statLabel___VSbgL {
  font-size: 11px;
  color: #71717a;
  font-weight: 500;
  margin-bottom: 2px;
}

.VisitsDueView-module__statValue___FPdaP {
  font-size: 22px;
  font-weight: 700;
  font-family: "IBM Plex Mono", monospace;
  color: #18181b;
}

.VisitsDueView-module__statValueyellow___S6Mhk {
  color: #854d0e;
}

.VisitsDueView-module__statValuered___jNXu2 {
  color: #991b1b;
}

.VisitsDueView-module__emptyState___Yd2BH {
  margin-top: 12px;
  padding: 24px;
  text-align: center;
  font-size: 14px;
  color: #71717a;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.VisitsDueView-module__layoutGrid___TkOs3 {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);
  gap: 16px;
  align-items: start;
  margin-top: 12px;
}

.VisitsDueView-module__listColumn___fG77i {
  min-width: 0;
}

.VisitsDueView-module__railColumn___G1RWB {
  position: sticky;
  top: 16px;
  max-height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 54px);
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 80px;
}

.VisitsDueView-module__railColumn___G1RWB::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.VisitsDueView-module__loaderWrap___YJWxU {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.VisitsDueView-module__railEmpty___uWdPi {
  padding: 24px;
  text-align: center;
  font-size: 13px;
  color: #71717a;
  background: #ffffff;
  border: 1px solid #dcdce0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__chipsRow___WQdEv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.VisitsDueView-module__chip___Hb7Y7 {
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.VisitsDueView-module__chip___Hb7Y7:hover {
  border-color: #a1a1aa;
}

.VisitsDueView-module__chipOn___ZW4BY {
  border-color: #18181b;
  background: #18181b;
  color: #fafafa;
}

.VisitsDueView-module__chipMono___PUibh {
  font-family: "IBM Plex Mono", monospace;
}

.VisitsDueView-module__chipDivider___vOUNB {
  width: 1px;
  height: 16px;
  background: #e4e4e7;
  margin: 0 4px;
}

.VisitsDueView-module__layoutToggle___fMdpf {
  display: flex;
  gap: 2px;
  margin-left: auto;
  padding: 2px;
  background: #f4f4f5;
  border-radius: 6px;
}

.VisitsDueView-module__layoutButton___CvXiB {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}
.VisitsDueView-module__layoutButton___CvXiB:hover {
  color: #18181b;
}

.VisitsDueView-module__layoutButtonOn___NrvAK {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__tableWrap___hb1Pk,
.VisitsDueView-module__cardGroup___zROmm {
  background: #ffffff;
  border: 1px solid #dcdce0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueView-module__table___E_ZSC {
  width: 100%;
  border-collapse: collapse;
}
.VisitsDueView-module__table___E_ZSC th {
  padding: 8px 12px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #71717a;
  border-bottom: 1px solid #d4d4d8;
}
.VisitsDueView-module__table___E_ZSC td {
  padding: 9px 12px;
  font-size: 13px;
  vertical-align: middle;
}
.VisitsDueView-module__table___E_ZSC tbody tr:not(.VisitsDueView-module__groupRow___z4y6d) {
  border-bottom: 1px solid #e4e4e7;
  cursor: pointer;
}
.VisitsDueView-module__table___E_ZSC tbody tr:not(.VisitsDueView-module__groupRow___z4y6d):hover {
  background: #fafafa;
}

.VisitsDueView-module__thMember___YeNev {
  width: 18%;
}

.VisitsDueView-module__thOpen___T8sd_ {
  width: 60px;
  text-align: right !important;
}

.VisitsDueView-module__groupRow___z4y6d td,
.VisitsDueView-module__cardGroupHeader___Xoz7c {
  padding: 8px 12px;
  background: #fafafa;
  border-bottom: 1px solid #d4d4d8;
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
}

.VisitsDueView-module__groupRow___z4y6d td {
  border-top: 1px solid #d4d4d8;
}

.VisitsDueView-module__groupCount___mGSxT {
  font-weight: 400;
  color: #a1a1aa;
}

.VisitsDueView-module__rowSelected___no9x_ {
  background: #fafafa;
}

.VisitsDueView-module__rowSelectedList___bui2r {
  background: #fafafa;
  box-shadow: inset 3px 0 0 #18181b;
}

.VisitsDueView-module__tdMember___EJZqm {
  font-weight: 600;
  color: #18181b;
}

.VisitsDueView-module__tdMono___WSbae {
  font-family: "IBM Plex Mono", monospace;
  color: #52525b;
}

.VisitsDueView-module__tdAnchor___ztX6K,
.VisitsDueView-module__tdMuted___LhPkn {
  color: #71717a;
}

.VisitsDueView-module__tdAnchor___ztX6K {
  max-width: 320px;
}

.VisitsDueView-module__pills___aXv2q {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.VisitsDueView-module__openButtons___C15gF {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}

.VisitsDueView-module__openButton___guxz4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: #18181b;
  color: #fafafa;
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.VisitsDueView-module__openButton___guxz4[aria-disabled=true] {
  opacity: 0.35;
  cursor: not-allowed;
}

.VisitsDueView-module__cardsWrap___AYRHo {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.VisitsDueView-module__gapCard___zSkVG {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #e4e4e7;
  cursor: pointer;
}
.VisitsDueView-module__gapCard___zSkVG:last-child {
  border-bottom: none;
}
.VisitsDueView-module__gapCard___zSkVG:hover {
  background: #fafafa;
}

.VisitsDueView-module__gapCardMain___TJFlb {
  min-width: 0;
  flex: 1;
}

.VisitsDueView-module__rowName___eCmhX {
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.VisitsDueView-module__gapCardTitle___HQJzl {
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
}

.VisitsDueView-module__gapCardEvidence___RIh2d {
  margin: 8px 0 0;
  padding-left: 10px;
  border-left: 2px solid #e4e4e7;
  font-size: 13px;
  color: #71717a;
}

.VisitsDueView-module__rowMeta___nphBk {
  margin-top: 8px;
  font-size: 12px;
  color: #a1a1aa;
}

.VisitsDueView-module__gapCardSide___wMVTB {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: 45%;
}
.VisitsDueView-module__gapCardSide___wMVTB .VisitsDueView-module__pills___aXv2q {
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/VisitsDueView/VisitsDueView.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,wDAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,qHAAA;EAIA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,QAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAHF;;AAMA;EACE,uCAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAHF;AAKE;EACE,cAAA;AAHJ;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAJF;;AAOA;;EAEE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAJF;;AAOA;EACE,WAAA;EACA,yBAAA;AAJF;AAME;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gCAAA;AAJJ;AAOE;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;AALJ;AAQE;EACE,gCAAA;EACA,eAAA;AANJ;AAQI;EACE,mBAAA;AANN;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,WAAA;EACA,4BAAA;AARF;;AAWA;;EAEE,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,mBAAA;EACA,iCAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,uCAAA;EACA,cAAA;AARF;;AAWA;;EAEE,cAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AARF;;AAWA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AARF;AAUE;EACE,aAAA;EACA,mBAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AATF;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;;AAcA;EACE,YAAA;EACA,OAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AAXF;AAaE;EACE,yBAAA;AAXJ","sourcesContent":[".root {\n  display: block;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  margin-bottom: 8px;\n}\n\n.readout {\n  margin-left: auto;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.statsRow {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.statCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.statLabel {\n  font-size: 11px;\n  color: #71717a;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.statValue {\n  font-size: 22px;\n  font-weight: 700;\n  font-family: 'IBM Plex Mono', monospace;\n  color: #18181b;\n}\n\n.statValueyellow {\n  color: #854d0e;\n}\n\n.statValuered {\n  color: #991b1b;\n}\n\n.emptyState {\n  margin-top: 12px;\n  padding: 24px;\n  text-align: center;\n  font-size: 14px;\n  color: #71717a;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.layoutGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);\n  gap: 16px;\n  align-items: start;\n  margin-top: 12px;\n}\n\n.listColumn {\n  min-width: 0;\n}\n\n.railColumn {\n  position: sticky;\n  top: 16px;\n  max-height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      54px\n  );\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding-bottom: 80px;\n}\n\n.railColumn::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.railEmpty {\n  padding: 24px;\n  text-align: center;\n  font-size: 13px;\n  color: #71717a;\n  background: #ffffff;\n  border: 1px solid #dcdce0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.chipsRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.chip {\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #52525b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n}\n\n.chipOn {\n  border-color: #18181b;\n  background: #18181b;\n  color: #fafafa;\n}\n\n.chipMono {\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.chipDivider {\n  width: 1px;\n  height: 16px;\n  background: #e4e4e7;\n  margin: 0 4px;\n}\n\n.layoutToggle {\n  display: flex;\n  gap: 2px;\n  margin-left: auto;\n  padding: 2px;\n  background: #f4f4f5;\n  border-radius: 6px;\n}\n\n.layoutButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    color: #18181b;\n  }\n}\n\n.layoutButtonOn {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.tableWrap,\n.cardGroup {\n  background: #ffffff;\n  border: 1px solid #dcdce0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n\n  th {\n    padding: 8px 12px;\n    text-align: left;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #71717a;\n    border-bottom: 1px solid #d4d4d8;\n  }\n\n  td {\n    padding: 9px 12px;\n    font-size: 13px;\n    vertical-align: middle;\n  }\n\n  tbody tr:not(.groupRow) {\n    border-bottom: 1px solid #e4e4e7;\n    cursor: pointer;\n\n    &:hover {\n      background: #fafafa;\n    }\n  }\n}\n\n.thMember {\n  width: 18%;\n}\n\n.thOpen {\n  width: 60px;\n  text-align: right !important;\n}\n\n.groupRow td,\n.cardGroupHeader {\n  padding: 8px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #d4d4d8;\n  font-size: 13px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.groupRow td {\n  border-top: 1px solid #d4d4d8;\n}\n\n.groupCount {\n  font-weight: 400;\n  color: #a1a1aa;\n}\n\n.rowSelected {\n  background: #fafafa;\n}\n\n.rowSelectedList {\n  background: #fafafa;\n  box-shadow: inset 3px 0 0 #18181b;\n}\n\n.tdMember {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.tdMono {\n  font-family: 'IBM Plex Mono', monospace;\n  color: #52525b;\n}\n\n.tdAnchor,\n.tdMuted {\n  color: #71717a;\n}\n\n.tdAnchor {\n  max-width: 320px;\n}\n\n.pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.openButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.openButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: #18181b;\n  color: #fafafa;\n  font-size: 11px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n\n  &[aria-disabled='true'] {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.cardsWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.gapCard {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #e4e4e7;\n  cursor: pointer;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #fafafa;\n  }\n}\n\n.gapCardMain {\n  min-width: 0;\n  flex: 1;\n}\n\n.rowName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.gapCardTitle {\n  margin: 4px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.gapCardEvidence {\n  margin: 8px 0 0;\n  padding-left: 10px;\n  border-left: 2px solid #e4e4e7;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.rowMeta {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.gapCardSide {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  max-width: 45%;\n\n  .pills {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `VisitsDueView-module__root___CS23J`,
	"toolbar": `VisitsDueView-module__toolbar___UkACy`,
	"readout": `VisitsDueView-module__readout___sXbXA`,
	"statsRow": `VisitsDueView-module__statsRow___G2L_N`,
	"statCard": `VisitsDueView-module__statCard___GcBeg`,
	"statLabel": `VisitsDueView-module__statLabel___VSbgL`,
	"statValue": `VisitsDueView-module__statValue___FPdaP`,
	"statValueyellow": `VisitsDueView-module__statValueyellow___S6Mhk`,
	"statValuered": `VisitsDueView-module__statValuered___jNXu2`,
	"emptyState": `VisitsDueView-module__emptyState___Yd2BH`,
	"layoutGrid": `VisitsDueView-module__layoutGrid___TkOs3`,
	"listColumn": `VisitsDueView-module__listColumn___fG77i`,
	"railColumn": `VisitsDueView-module__railColumn___G1RWB`,
	"loaderWrap": `VisitsDueView-module__loaderWrap___YJWxU`,
	"railEmpty": `VisitsDueView-module__railEmpty___uWdPi`,
	"chipsRow": `VisitsDueView-module__chipsRow___WQdEv`,
	"chip": `VisitsDueView-module__chip___Hb7Y7`,
	"chipOn": `VisitsDueView-module__chipOn___ZW4BY`,
	"chipMono": `VisitsDueView-module__chipMono___PUibh`,
	"chipDivider": `VisitsDueView-module__chipDivider___vOUNB`,
	"layoutToggle": `VisitsDueView-module__layoutToggle___fMdpf`,
	"layoutButton": `VisitsDueView-module__layoutButton___CvXiB`,
	"layoutButtonOn": `VisitsDueView-module__layoutButtonOn___NrvAK`,
	"tableWrap": `VisitsDueView-module__tableWrap___hb1Pk`,
	"cardGroup": `VisitsDueView-module__cardGroup___zROmm`,
	"table": `VisitsDueView-module__table___E_ZSC`,
	"groupRow": `VisitsDueView-module__groupRow___z4y6d`,
	"thMember": `VisitsDueView-module__thMember___YeNev`,
	"thOpen": `VisitsDueView-module__thOpen___T8sd_`,
	"cardGroupHeader": `VisitsDueView-module__cardGroupHeader___Xoz7c`,
	"groupCount": `VisitsDueView-module__groupCount___mGSxT`,
	"rowSelected": `VisitsDueView-module__rowSelected___no9x_`,
	"rowSelectedList": `VisitsDueView-module__rowSelectedList___bui2r`,
	"tdMember": `VisitsDueView-module__tdMember___EJZqm`,
	"tdMono": `VisitsDueView-module__tdMono___WSbae`,
	"tdAnchor": `VisitsDueView-module__tdAnchor___ztX6K`,
	"tdMuted": `VisitsDueView-module__tdMuted___LhPkn`,
	"pills": `VisitsDueView-module__pills___aXv2q`,
	"openButtons": `VisitsDueView-module__openButtons___C15gF`,
	"openButton": `VisitsDueView-module__openButton___guxz4`,
	"cardsWrap": `VisitsDueView-module__cardsWrap___AYRHo`,
	"gapCard": `VisitsDueView-module__gapCard___zSkVG`,
	"gapCardMain": `VisitsDueView-module__gapCardMain___TJFlb`,
	"rowName": `VisitsDueView-module__rowName___eCmhX`,
	"gapCardTitle": `VisitsDueView-module__gapCardTitle___HQJzl`,
	"gapCardEvidence": `VisitsDueView-module__gapCardEvidence___RIh2d`,
	"rowMeta": `VisitsDueView-module__rowMeta___nphBk`,
	"gapCardSide": `VisitsDueView-module__gapCardSide___wMVTB`
};
module.exports = ___CSS_LOADER_EXPORT___;
